import { render, staticRenderFns } from "./ProductSummaryRefactored.vue?vue&type=template&id=148ab5b6"
import script from "./ProductSummaryRefactored.vue?vue&type=script&lang=js"
export * from "./ProductSummaryRefactored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports